module.exports = __webpack_public_path__ + "9d9a98c84824914136d43a2253855f87.svg";